import request from "../../../app/api/requests";
import { focusedTaskSlice } from "../model/focus-task.slice";

export const changeFocusVariant = (variant: 0 | 1) => {
    return async (dispatch: any, getState: any) => {
        dispatch(focusedTaskSlice.actions.changeVariantView({ varinatView: variant }))
        try {
            const settings = getState().settings.settings
            if (settings?.userId) {
                await request.put('/Settings/', {
                    userId: settings.userId,
                    settingsType: settings.settingsType,
                    isSmartDateRecognition: settings.isSmartDateRecognition,
                    isTimeTracking: settings.isTimeTracking,
                    timeZone: settings.timeZone,
                    currentTimeZone: settings.currentTimeZone,
                    timeZoneId: settings.timeZoneId,
                    currentTimeZoneId: settings.currentTimeZoneId,
                    isGCalendarIntegrated: settings.isGCalendarIntegrated,
                    focusMode: variant,
                })
            }
        } catch (error) {
            console.error('Failed to save focus view variant:', error)
        }
    }
}
